module.exports = __webpack_public_path__ + "static/media/mark.e2cc9ad5.jpg";